import { useState } from "react";
import {
 Container, Section, PageHero, SectionHeading, ServiceCard, CtaBanner, TrustStrip,
} from "../components/common";
import { useServices } from "../lib/api";
import { useSeo, breadcrumbLd } from "../lib/seo";

export default function Services() {
 const { data: services = [] } = useServices();
 const [cat, setCat] = useState("All");
 const cats = ["All", ...Array.from(new Set(services.map((s) => s.category)))];
 const shown = cat === "All" ? services : services.filter((s) => s.category === cat);

 useSeo({
 title: "Auto Repair & Mechanic Services in Riverside, CA | RPM Auto Repair",
 description: "Full-service auto repair in Riverside from ASE certified mechanics: brakes, engine, transmission, oil changes, diagnostics, hybrid, diesel, smog & more. Nationwide warranty. Right off the 215 Fwy.",
 path: "/services",
 jsonLd: [breadcrumbLd([{ name: "Home", path: "/" }, { name: "Services", path: "/services" }])],
 });

 return (
 <>
 <PageHero eyebrow="What We Do" title="Complete Auto Repair & Maintenance"
 subtitle="One trusted shop for everything your vehicle needs, from routine maintenance to complex repairs, on all makes and models."
 image="https://images.unsplash.com/photo-1676018366904-c083ed678e60?w=1400&q=80"
 crumbs={[{ name: "Home", path: "/" }, { name: "Services", path: "/services" }]} />
 <TrustStrip />
 <Section>
 <Container>
 <div className="mb-10 flex flex-wrap gap-2" data-testid="service-filters">
 {cats.map((c) => (
 <button key={c} onClick={() => setCat(c)} data-testid={`filter-${c.toLowerCase()}`}
 className={`rounded-full px-4 py-2 text-sm font-semibold tracking-wide transition-colors ${cat === c ? "bg-primary text-white" : "border border-white/15 text-muted-foreground hover:border-primary hover:text-white"}`}>
 {c}
 </button>
 ))}
 </div>
 <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
 {shown.map((s, i) => <ServiceCard key={s.slug} svc={s} index={i} />)}
 </div>
 </Container>
 </Section>
 <CtaBanner />
 </>
 );
}
